import RecipeProfitGraph from './RecipeProfitGraph';
export default RecipeProfitGraph;
